import '../globalStyles/fonts.css';
import './i18n';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import serviceWorkerConfig from './config/serviceWorkerConfig';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const container = document.getElementById('root');
if (!container) throw new Error('Something went wrong!');
const root = createRoot(container);
root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register(serviceWorkerConfig);
